module.exports = require("@swa-ui/browser/window");